module.exports = __webpack_public_path__ + "img/GAME_MULTI JANGGI2.7e7a8692.jpg";